import React from 'react';
import { Box, Paper, Typography, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import BlockIcon from '@mui/icons-material/Block';
import { CapacityInfo } from '~/types/transition';

interface CapacityFactorCardProps {
  capacity: CapacityInfo;
}

const CapacityFactorCard: React.FC<CapacityFactorCardProps> = ({ capacity }) => {
  const isGreen = capacity.recommendation === 'ACCEPT';
  const isYellow = capacity.recommendation === 'DELAYED_START';

  const chipColor = isGreen ? 'success' : isYellow ? 'warning' : 'error';
  const chipIcon = isGreen ? (
    <CheckCircleIcon fontSize="small" />
  ) : isYellow ? (
    <WarningAmberIcon fontSize="small" />
  ) : (
    <BlockIcon fontSize="small" />
  );

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        Capacity
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, mb: 1.5 }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 110 }}>Territory</Typography>
          <Typography variant="body2" fontWeight={600}>{capacity.territory}</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 110 }}>Available slots</Typography>
          <Typography variant="body2" fontWeight={600}>{capacity.availableCount}</Typography>
        </Box>
      </Box>
      <Chip
        icon={chipIcon}
        label={capacity.recommendationLabel}
        color={chipColor}
        size="small"
        sx={{ fontSize: '0.7rem', height: 'auto', py: 0.5, '& .MuiChip-label': { whiteSpace: 'normal' } }}
      />
    </Paper>
  );
};

export default CapacityFactorCard;
